//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'TargetHeight',
  data() {
    return {
      defaultJson:{
        "Mother's Height": "母亲身高",
        "Target Height": "理想身高",
        "Father's Height": "父亲身高"
      },
      form:{
        mh:'',
        fh:'',
        gender:'0'
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'男'},
        {value:"1",name:'女'},
      ],
      minScore:'--',
      maxScore:'--'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {  
        // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
        let result = form.gender==0 ?	(form.fh + form.mh + 13) / 2 :	(form.fh + form.mh - 13) / 2
        self.minScore = (result - 8.5).toFixed(0)
        self.maxScore = (result + 8.5).toFixed(0)
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/TargetHeight.vue